import { useState } from "react";
import {
  TransportFeed,
  TransportIdentifier,
  TransportInformation,
} from "../redux/types";

export const useTransportService = (transportFeeds?: TransportFeed[]) => {
  const feedId = transportFeeds?.[0]?.id;
  const [selection, setSelection] = useState<{
    feedId?: string;
    service: string | null;
  }>({ service: null });
  const selectedTransportService =
    selection.feedId === feedId &&
    transportFeeds?.[0]?.services.some(
      ({ lineName }) => lineName === selection.service,
    )
      ? selection.service
      : null;
  const setSelectedTransportService = (service: string | null) =>
    setSelection({ feedId, service });

  if (!transportFeeds?.length) {
    return {
      transportInformation: undefined,
      transportIdentifiers: undefined,
      selectedTransportService,
      setSelectedTransportService,
    };
  }

  const { transportMode, isTimetableData, services } = transportFeeds[0];

  const transportInformation: TransportInformation = {
    transportMode,
    isTimetableData,
    services: selectedTransportService
      ? services.filter(({ lineName }) => lineName === selectedTransportService)
      : services,
  };

  // Unnamed services still contribute departures, but cannot be filter buttons.
  const transportIdentifiers: TransportIdentifier[] = services.flatMap(
    ({ lineName, lineColour }) =>
      lineName && lineName.trim()
        ? [{ code: lineName, colour: lineColour }]
        : [],
  );

  return {
    transportInformation,
    transportIdentifiers,
    selectedTransportService,
    setSelectedTransportService,
  };
};
